import * as search from '../actions/search.actions'

export interface State {
  term: string
}

const initialState: State = {
  term: null
}

export function reducer(
  state = initialState,
  action: search.Actions
): State {

  switch (action.type) {
    case search.SET_SEARCH_TERM:
      return {
        ...state,
        term: action.payload
      }

      case search.CLEAR_SEARCH_TERM:
        return {
          ...state,
          term: null
        }

      default:
        return state
  }
}

export const getSearchTerm = (state: State) => state.term

